import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "verificationStatus" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.showDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDialog) = $event)),
    class: "successDialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("dialog.sent_fail")), 1)
      ]),
      _createVNode(_component_Button, {
        class: "defaultButton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        style: {"justify-content":"center"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("dialog.close")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}